import { useTheme } from "@material-ui/core"
const PigIcon = (pros) => {
    const theme = useTheme()
    return (
        <div {...pros}>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="18.000000pt" height="18.000000pt" viewBox="0 0 50.000000 50.000000"
                preserveAspectRatio="xMidYMid meet">

                <g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
                    fill={theme.palette.primary.main} stroke="none">
                    <path d="M132 447 c-12 -13 -22 -35 -22 -50 0 -15 1 -27 3 -27 1 0 20 7 42 15
                22 8 55 14 73 15 38 0 42 17 9 48 -31 29 -77 29 -105 -1z"/>
                    <path d="M345 420 c-12 -4 -27 -15 -34 -24 -9 -11 -30 -16 -65 -16 -63 0 -146
                -38 -166 -75 -12 -23 -15 -24 -29 -10 -13 13 -13 19 -3 35 10 17 10 20 -3 20
                -26 0 -30 -48 -6 -74 13 -14 21 -35 21 -58 0 -21 10 -50 25 -73 15 -22 23 -44
                20 -55 -4 -12 2 -24 17 -34 29 -21 55 -20 67 1 14 25 91 24 112 -1 22 -26 72
                -10 79 26 6 32 51 85 76 90 15 3 19 12 19 48 0 39 -3 45 -22 48 -13 2 -23 10
                -23 19 0 8 -14 28 -31 44 -27 25 -30 34 -25 64 7 37 4 39 -29 25z m35 -170 c0
                -11 -7 -20 -15 -20 -8 0 -15 9 -15 20 0 11 7 20 15 20 8 0 15 -9 15 -20z"/>
                </g>
            </svg>
        </div>
    )
}
export default PigIcon